import { images } from '../constants';

const services = [
    {
        id: 1,
        image: images.service1,
        title: 'Lock Installation',
        content: 'Professional lock installation services for homes, businesses, and vehicles.',
        paragraphs: [
            'Secure your property with our expert lock installation services. We handle a wide range of lock types for residential, commercial, and automotive applications, ensuring safety and peace of mind.',
            "Our team is trained to install everything from traditional deadbolts to advanced smart locks with precision and care. Whether you're upgrading your home security or outfitting a new office, we provide fast, reliable, and affordable service."
        ],
        gallery: [
            images.service1Gallery1,
            images.service1Gallery2
        ],
        features: [
            'Residential & Commercial Lock Fitting',
            'Smart Lock Integration',
            'High-Security Lock Options',
            'Fast & Precise Installation',
            'Certified Locksmith Professionals'
        ],
        procedure: [
            'Initial Security Assessment',
            'Lock Type Recommendation',
            'On-Site Installation',
            'Function Testing',
            'Final Walkthrough & Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of locks do you install?',
                content: 'We install all types of locks including deadbolts, knob locks, smart locks, mortise locks, and high-security systems for homes, offices, and vehicles.'
            },
            {
                id: 2,
                heading: 'Do you install smart locks?',
                content: 'Yes, we specialize in smart lock installation and setup, including Wi-Fi, Bluetooth, and keypad entry systems.'
            },
            {
                id: 3,
                heading: 'How long does a lock installation take?',
                content: 'Most standard lock installations take about 30–60 minutes. Complex systems may take longer depending on the requirements.'
            },
            {
                id: 4,
                heading: 'Is your service available for emergency needs?',
                content: 'Yes, we offer emergency lock installation and replacement services. Contact us for immediate assistance.'
            }
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: 'Key Duplication',
        content: 'Efficient key duplication services to provide spare keys for your convenience.',
        paragraphs: [
            'Never get locked out again—our key duplication services are fast, accurate, and reliable. We create high-quality copies for a wide range of keys including residential, commercial, automotive, and specialty keys.',
            'Using precision cutting machines and experienced technicians, we ensure every duplicate key functions perfectly. Whether you need one spare or several, we’ve got you covered with minimal wait times and maximum convenience.'
        ],
        gallery: [
            images.service2Gallery1,
            images.service2Gallery2
        ],
        features: [
            'Fast & Accurate Key Copies',
            'Wide Key Type Compatibility',
            'On-Site & In-Store Services',
            'High-Quality Key Blanks',
            'Affordable & Reliable'
        ],
        procedure: [
            'Original Key Inspection',
            'Key Type Matching',
            'Precision Cutting',
            'Quality Check',
            'Customer Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What types of keys can you duplicate?',
                content: 'We can duplicate most standard house, office, car, and specialty keys. Some high-security or coded keys may require verification or special equipment.'
            },
            {
                id: 2,
                heading: 'How long does it take to duplicate a key?',
                content: 'Most key duplications take less than 5 minutes, depending on the key type and volume of copies needed.'
            },
            {
                id: 3,
                heading: 'Can you duplicate car keys with chips?',
                content: 'Yes, we offer transponder key duplication and programming for many vehicle models. Contact us with your vehicle details for compatibility.'
            },
            {
                id: 4,
                heading: 'Is it safe to duplicate my key with you?',
                content: 'Absolutely. Our team handles all key duplication requests professionally and ensures your privacy and security are respected at all times.'
            }
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: 'Lock Repair',
        content: 'Expert lock repair services to fix damaged or malfunctioning locks.',
        paragraphs: [
            'Don’t replace your lock when a reliable repair will do. Our lock repair specialists restore functionality to worn, jammed, or broken locks—helping you save time and money.',
            'Whether it’s a residential deadbolt, commercial door lock, or antique mechanism, we diagnose and fix the issue with precision and care. We aim to extend the life of your existing hardware while ensuring your property remains secure.'
        ],
        gallery: [
            images.service3Gallery1,
            images.service3Gallery2
        ],
        features: [
            'Residential & Commercial Repairs',
            'Stuck or Jammed Lock Solutions',
            'Broken Key Extraction',
            'Handle & Mechanism Fixes',
            'Fast On-Site Assistance'
        ],
        procedure: [
            'Lock Assessment',
            'Issue Diagnosis',
            'Internal Mechanism Repair',
            'Functionality Testing',
            'Final Adjustments & Handover'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Can all types of locks be repaired?',
                content: 'Most mechanical locks can be repaired. Some high-tech or severely damaged locks may require replacement, which we will advise on after inspection.'
            },
            {
                id: 2,
                heading: 'How long does a lock repair take?',
                content: 'Simple repairs may take 15–30 minutes. Complex internal damage or older lock types may require more time or parts replacement.'
            },
            {
                id: 3,
                heading: 'Is it cheaper to repair or replace a lock?',
                content: 'In many cases, repairing a lock is more cost-effective than replacing it. We assess each case and recommend the most secure and economical option.'
            },
            {
                id: 4,
                heading: 'Do you offer emergency lock repair?',
                content: 'Yes, we provide emergency lock repair services for homes, offices, and vehicles. Contact us for rapid assistance anytime you’re in need.'
            }
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: 'Security Consultation',
        content: 'Comprehensive security consultations to assess and enhance your property\'s safety measures.',
        paragraphs: [
            'Protecting your home or business starts with a professional security assessment. Our consultations help identify vulnerabilities, recommend improvements, and create a customized security plan tailored to your needs.',
            'From entry points and lock systems to surveillance and access control, we evaluate every aspect of your security setup to ensure peace of mind and long-term protection.'
        ],
        gallery: [
            images.service4Gallery1,
            images.service4Gallery2
        ],
        features: [
            'In-Depth Risk Assessment',
            'Personalized Security Plans',
            'Residential & Commercial Focus',
            'Upgrade Recommendations',
            'Expert Guidance & Support'
        ],
        procedure: [
            'Initial Site Visit',
            'Security Audit & Analysis',
            'Report of Findings',
            'Customized Recommendations',
            'Ongoing Support & Follow-Up'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What does a security consultation include?',
                content: 'It includes a full evaluation of your locks, entry points, lighting, surveillance, and more—followed by a detailed report and safety recommendations.'
            },
            {
                id: 2,
                heading: 'Is this service for homes or businesses?',
                content: 'Both. We tailor our consultations to suit residential properties, retail stores, offices, warehouses, and more.'
            },
            {
                id: 3,
                heading: 'Can you help with implementing the recommended changes?',
                content: 'Yes, we offer full support to carry out suggested upgrades, including hardware installation, system integration, and follow-up checks.'
            },
            {
                id: 4,
                heading: 'How long does a consultation take?',
                content: 'A typical consultation takes 1–2 hours depending on property size and complexity. A detailed report is usually delivered within 24–48 hours.'
            }
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: 'Lockout Assistance',
        content: '24/7 emergency lockout assistance to help you regain access to your property swiftly.',
        paragraphs: [
            'Locked out of your home, office, or vehicle? Our emergency lockout service is available around the clock to get you back inside quickly and safely—no damage, no stress.',
            'With fast response times and skilled technicians, we ensure minimal disruption and maximum efficiency. We handle all lock types with the utmost care and professionalism.'
        ],
        gallery: [
            images.service5Gallery1,
            images.service5Gallery2
        ],
        features: [
            '24/7 Emergency Availability',
            'Fast Response Time',
            'Non-Destructive Entry Methods',
            'Home, Business & Vehicle Lockouts',
            'Certified Locksmith Technicians'
        ],
        procedure: [
            'Emergency Call Received',
            'Location Confirmation & Dispatch',
            'On-Site Assessment',
            'Safe Lock Opening',
            'Optional Lock Replacement (if needed)'
        ],
        faqs: [
            {
                id: 1,
                heading: 'What should I do if I’m locked out?',
                content: 'Stay calm and contact our 24/7 emergency number. We’ll dispatch a locksmith to your location as soon as possible.'
            },
            {
                id: 2,
                heading: 'Can you open my door without damaging the lock?',
                content: 'Yes. Our technicians use non-destructive techniques whenever possible to preserve your existing lock.'
            },
            {
                id: 3,
                heading: 'How quickly can you reach me?',
                content: 'We aim to reach most locations within 20–30 minutes, depending on traffic and distance.'
            },
            {
                id: 4,
                heading: 'Is this service available on holidays and weekends?',
                content: 'Absolutely. Our lockout assistance is available 24/7, including weekends and holidays.'
            }
        ]
    },
    {
        id: 6,
        image: images.service6,
        title: 'Master Key',
        content: 'Customized master key systems for efficient access control and security management.',
        paragraphs: [
            'Simplify your access control with a tailored master key system. Ideal for property managers, office buildings, or large facilities, these systems allow designated individuals to access multiple areas with a single key.',
            'Our expert locksmiths design scalable systems that balance convenience and security. Whether you need a single master key or a multi-tiered access hierarchy, we’ve got you covered.'
        ],
        gallery: [
            images.service6Gallery1,
            images.service6Gallery2
        ],
        features: [
            'Custom Master Key Design',
            'Access Hierarchy Setup',
            'Compatible with Existing Locks',
            'Secure Key Distribution',
            'Scalable for Future Expansion'
        ],
        procedure: [
            'Initial Access Needs Assessment',
            'System Design & Approval',
            'Lock Compatibility Check',
            'Master Key System Implementation',
            'Ongoing Support & Adjustments'
        ],
        faqs: [
            {
                id: 1,
                heading: 'Who benefits from a master key system?',
                content: 'Property managers, business owners, schools, and facility managers often use master key systems to simplify and control access.'
            },
            {
                id: 2,
                heading: 'Can I upgrade my current locks to a master key system?',
                content: 'Yes, in many cases existing locks can be rekeyed or replaced to fit into a master key structure.'
            },
            {
                id: 3,
                heading: 'Is the system secure?',
                content: 'Absolutely. Each user only accesses authorized areas, while administrators retain complete control via the master key.'
            },
            {
                id: 4,
                heading: 'Can you expand the system in the future?',
                content: 'Yes, our master key systems are designed with scalability in mind, allowing seamless upgrades as your needs grow.'
            }
        ]
    }

];

export default services;